import { cn } from '@src/design-system/helpers';

import {
  TiclickDatePicker,
  TiclickDatePickerCalendarPopover,
  TiclickDatePickerCalendarPopoverTrigger,
} from '@src/design-system/ticlick-date-picker';
import { CalendarIcon } from 'lucide-react';
import type { DateValue } from 'react-aria-components';

type TDateRangeOptionProps = {
  onSingleDateValueChange: (v: DateValue | null) => void;
  onRangeDateValueChange: (
    v: { start: DateValue; end: DateValue } | null
  ) => void;
  onOptionClick: () => void;
  label: string;
  isSingleDate: boolean;
  type: string;
  isSelected: boolean;
};

export const DateRangeOption = ({
  isSelected,
  label,
  isSingleDate,
  onSingleDateValueChange,
  onRangeDateValueChange,
  onOptionClick,
  type,
}: TDateRangeOptionProps) => {
  const shouldShowCalendar = type === 'date';

  return (
    // @ts-expect-error
    <TiclickDatePicker
      onChange={isSingleDate ? onSingleDateValueChange : onRangeDateValueChange}
      mode={isSingleDate ? 'single' : 'range'}
    >
      <TiclickDatePickerCalendarPopoverTrigger
        className={cn(
          'p-2 text-sm hover:bg-primary-30 cursor-pointer flex w-full justify-between items-center',
          isSelected && 'bg-primary-50 text-primary-900 hover:bg-primary-30'
        )}
        onClick={!shouldShowCalendar ? onOptionClick : () => {}}
      >
        {label}
        {shouldShowCalendar && <CalendarIcon size={16} />}
      </TiclickDatePickerCalendarPopoverTrigger>

      {shouldShowCalendar && (
        <TiclickDatePickerCalendarPopover
          closeOnSelect
          align='start'
        />
      )}
    </TiclickDatePicker>
  );
};
